import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {Device} from 'src/app/infrastructure/moovement-api/models/asset';

interface AddWaterPointState {
  name: string | undefined,
  lat: number | undefined,
  long: number | undefined,
  nominalValue: number | undefined,
  datum: number | undefined,
  highAlertThreshold: number | undefined,
  highWarningThreshold: number | undefined,
  lowWarningThreshold: number | undefined,
  lowAlertThreshold: number | undefined,
  deviceToMatch: Device | undefined,
  id: string | undefined
}

const initialState: AddWaterPointState = {
  name: undefined,
  lat: undefined,
  long: undefined,
  nominalValue: undefined,
  datum: undefined,
  highAlertThreshold: undefined,
  highWarningThreshold: undefined,
  lowWarningThreshold: undefined,
  lowAlertThreshold: undefined,
  deviceToMatch: undefined,
  id: undefined
};

export const AddWaterPointStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setName(name: string | undefined) {
      patchState(store, {name});
    },
    setLat(lat: number | undefined) {
      patchState(store, {lat});
    },
    setLong(long: number | undefined) {
      patchState(store, {long});
    },
    setNominalValue(nominalValue: number | undefined) {
      patchState(store, {nominalValue});
    },
    setDatum(datum: number | undefined) {
      patchState(store, {datum});
    },
    setHighAlertThreshold(highAlertThreshold: number | undefined) {
      patchState(store, {highAlertThreshold});
    },
    setHighWarningThreshold(highWarningThreshold: number | undefined) {
      patchState(store, {highWarningThreshold});
    },
    setLowWarningThreshold(lowWarningThreshold: number | undefined) {
      patchState(store, {lowWarningThreshold});
    },
    setLowAlertThreshold(lowAlertThreshold: number | undefined) {
      patchState(store, {lowAlertThreshold});
    },
    setDeviceToMatch(deviceToMatch: Device | undefined) {
      patchState(store, {deviceToMatch});
    },
    setId(id: string | undefined) {
      patchState(store, {id});
    },
    reset() {
      patchState(store, initialState);
    }
  })
));
